
import CustomerRefundPaymentsApiV2 from 'api/v2/admins/customer-refund-payments-api-v2'
import TitlePage from 'components/atoms/title-page'
import { RefundPaymentFilterForm } from 'domains/customer-refund-payment/organisms/form/refund-payment-filter-form'
import RefundPaymentTable from 'domains/customer-refund-payment/organisms/refund-payment-table/refund-payment-table'
import PropTypes from 'prop-types'
import React, {  useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Badge, Button, Col, Row } from 'reactstrap'
import ParamsUtil from 'utils/params-util'

const DEFAULT_FILTERS = {
  page    : 1,
  perPage : 10
}

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const CustomerRefundPaymentListPage = ({ pageUtils }) => {
  const [ refundPayments, setRefundPayments ] = useState([])
  const [ pagination, setPagination ]         = useState({})
  const [ isLoading, setIsLoading ]           = useState(true)
  const history                               = useHistory()

  // new filters implementation

  const filters  = Object.fromEntries(new URLSearchParams())
  const pathName = Object.fromEntries(new URLSearchParams()).pathname

  useEffect(() => {
    handleFetchRefundPayment()
  }, [  ])

  // Method to Fetch ::Customer::Refund::Payment from server
  const handleFetchRefundPayment = () => {
    setIsLoading(true)
    let params          = DEFAULT_FILTERS
    const isEmptyParams = Object.keys(filters).length === 0

    if (!isEmptyParams) {
      params = filters
    }

    CustomerRefundPaymentsApiV2.get(params)
      .then((response) => {
        const data = response.data.refund_payments
        const meta = response.data.meta
        setRefundPayments(data)
        setPagination(meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  const handleSubmitFilter = (values, formik) => {
    //remove empty attributes from params
    let params = ParamsUtil.removeEmptyAttributes(values)
    //reset page
    params = ParamsUtil.removeAttributeFromObject('page',params)

    history.push({
      pathname : pathName,
      search   : new URLSearchParams(params).toString()
    })

    formik.setSubmitting(false)
  }

  const handleResetFilter = () => history.push({ pathname: pathName })

  const handlePageChange = (page) => {
    const params = filters
    //replace page value
    params[ 'page' ] = page

    history.push({
      pathname : pathName,
      search   : new URLSearchParams(params).toString()
    })
  }

  const handleClickRemoveFilter = (key) => {
    let params    = filters
    params[ key ] = ''
    params        = ParamsUtil.removeEmptyAttributes(params)

    history.push({
      pathname : pathName,
      search   : new URLSearchParams(params).toString()
    })
  }

  return (
    <>
      <TitlePage mainTitle='Refund Payments'/>
      <h5 className='text-muted'>FILTERS</h5>

      <Row>
        <Col className='col-xl-2'>
          <RefundPaymentFilterForm
            onClickSubmitForm={ handleSubmitFilter }
            filterValues={ filters }
            onClickReset={ handleResetFilter }
          />
        </Col>

        <Col className='col-xl-10' >
          <div className='mb-3'>
            <h5 className='text-muted text-uppercase'>Applied Filters</h5>
            {
              Object.keys(filters).map((key) => (
                <Badge color='primary' key={ `payment-method-filters-${key}` }>
                  <div className='d-flex justify-content-between'>
                    <span className='align-self-center'>{ key }: { filters[ key ] }</span>
                    <Button close onClick={ () => handleClickRemoveFilter(key) } />
                  </div>

                </Badge>
              ))
            }
          </div>

          <RefundPaymentTable
            tableProps={{
              size       : 'sm',
              responsive : true,
              hover      : true
            }}
            refundPayments={ refundPayments }
            pagination={ pagination }
            isLoading={ isLoading }
            onPageChange={ handlePageChange }
          />
        </Col>
      </Row>

    </>
  )
}

CustomerRefundPaymentListPage.propTypes = propTypes

export default CustomerRefundPaymentListPage
